import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Alert, Box, CircularProgress, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import TopSection from "../../../LT/TopSection";
import ButtonComponent from "../../../../components/common/button/Button";
import DataDetails from "./DataDetails";
import Modal from "../../../../components/common/modal/Modal";
import "./DataErrors.css";
import { fetchDataErrors } from "../../../../redux/actions/DataErrors";
import { resolvePriceMemo } from "../../../../redux/actions/Resolve";
import { sendErrorMail } from "../../../../redux/actions/SendEmail";
import { Loader } from "../../../../components/common/Loader";
import { undoDataErrorApi } from "../../../../redux/actions/UndoDataError";
import { undoDataErrorEndpoint } from "../../../../common/endpoints";
import { getPriceMemoEmailApi } from "../../../../redux/actions/SendEmail/GetPriceMemoEmail";
import { getCpsMemberEmailApi } from "../../../../redux/actions/SendEmail/GetCpsMemberEmail";
import { MultiDropdown } from "../../../../components/common/MultiDropdown";
import { setSelectedItem } from "../../../../redux/actions/SupportTicket/selectionSlice";

const ModalFooter = (props) => {
  const disable = !(props?.selectedPriceMemoManagerEmail.length > 0);
  return (
    <div className="footer-btn-wrapper">
      <ButtonComponent
        maxWidth="170px"
        label="Cancel"
        bgColor="white"
        color="black"
        onClick={props.onClosePopup}
      />
      <ButtonComponent
        maxWidth="170px"
        label="Send"
        bgColor="black"
        color="white"
        onClick={props.onSubmitPopup}
        disabled={disable}
      />
    </div>
  );
};

const DataErrors = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnDisabled, setIsBtnDisabled] = useState(true);
  const [seqId, setSeqId] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const procurementDivisionType = useSelector(
    (state) => state?.userCardType?.procurementDivisionType
  );
  const userEmail = localStorage?.getItem('data');
  const userName = localStorage.getItem("userName");
  const plantId = localStorage.getItem("selectedCDPlantCode");
  const data = useSelector((state) => state?.dataErrors);
  const [open, setOpen] = useState(false);
  // const [resolveDisable, setResolveDisable] = useState();
  const [undoBtnDisable, setUndoBtnDisable] = useState();
  const [loading, setLoading] = useState(false);
  const [priceMemoManagerEmails, setPriceMemoManagerEmails] = useState([]);
  const [cpsMemberEmails, setCpsMemberEmails] = useState([]);
  const [selectedPriceMemoManagerEmail, setSelectedPriceMemoManagerEmail] = useState([]);
  const [selectedCPSMemberEmail, setSelectedCPSMemberEmail] = useState([]);
  const [reqBody, setReqBody] = useState({
    runOutputSeqId: '',
    sapSupplierId: '',
    sapMaterialNumber: '',
    manufacturingLeadTime: '',
    paymentTerms: '',
    currency: '',
    uom: ''
  });
  const userRole = localStorage.getItem("CDRole");

  const handleClose = () => {
    setOpen(false);
  };

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const handleCellValueChange = async (params) => {
    if (rowsData.some(row => row.runOutputSeqId === params.data.runOutputSeqId)) {
      const updatedSelectedRows = rowsData.map(row =>
        row.runOutputSeqId === params.data.runOutputSeqId ? params.data : row
      );
      setRowsData(updatedSelectedRows);
    }
  };

  const pagination = true;
  const paginationPageSize = 30;
  const paginationPageSizeSelector = [30, 50, 100, 500, 2000];

  const onSelectionChanged = (params) => {
    const selectedRowsOnCurrentPage = [];
    const currentPage = params.api.paginationGetCurrentPage();
    const pageSize = params.api.paginationGetPageSize();
    let index = 0;

    params.api.forEachNodeAfterFilterAndSort((node) => {
      const nodePage = Math.floor(index / pageSize);
      if (nodePage === currentPage && node.isSelected()) {
        selectedRowsOnCurrentPage.push(node.data);
      }
      index++;
    });

    setRowsData(selectedRowsOnCurrentPage);
    dispatch(setSelectedItem(selectedRowsOnCurrentPage));

    const listOfIds = selectedRowsOnCurrentPage.map((row) => row?.runOutputSeqId);
    setSeqId(listOfIds);

    const undoVal = selectedRowsOnCurrentPage.map((row) => row?.userDefinedError);
    const allTrue = undoVal.every((val) => val === true);
    setUndoBtnDisable(!allTrue);

    selectedRowsOnCurrentPage.length
      ? setIsBtnDisabled(false)
      : setIsBtnDisabled(true);
  };

  // const onSelectionChanged = (params) => {
  //   const displayedRows = [];
  //   params.api.forEachNodeAfterFilterAndSort((node) => {
  //     if(node.isSelected()) {
  //       displayedRows.push(node.data);
  //     }
  //   });
  
  //   const startIndex = (params.api.paginationGetCurrentPage() * params.api.paginationGetPageSize());
  //   const endIndex = startIndex + params.api.paginationGetPageSize();

  //   const rowsInCurrentPage = displayedRows.slice(startIndex, endIndex);

  //   const selectedRows = rowsInCurrentPage.filter((row) =>
  //     params.api.getSelectedNodes().some((node) => node.data === row)
  //   );
  //   setRowsData(selectedRows);
  //   dispatch(setSelectedItem(selectedRows));
  
  //   const listOfIds = selectedRows.map((list) => list?.runOutputSeqId);
  //   setSeqId(listOfIds);
  //   const undoVal = selectedRows.map((row) => row?.userDefinedError);
  //   const allTrue = undoVal.every((val) => val === true);
  //   setUndoBtnDisable(!allTrue);
  //   selectedRows.length ? setIsBtnDisabled(false) : setIsBtnDisabled(true);
  // };

  useEffect(() => {
    let reqBodyData = [];
    if (procurementDivisionType === "SIS") {
      reqBodyData = rowsData.map((row) => ({
        runOutputSeqId: row?.runOutputSeqId,
        sapSupplierId: row?.sapSupplierId,
        sapMaterialNumber: row?.sapMaterialNumber,
        manufacturingLeadTime: row?.manufacturingLeadTime,
        paymentTerms: row?.paymentTerms,
        currency: row?.currency,
        uom: row?.uom
      }));
    } else if (procurementDivisionType === "Agri") {
      reqBodyData = rowsData.map((row) => ({
        runOutputSeqId: row?.runOutputSeqId,
        sapSupplierId: row?.vendorNumber,
        sapMaterialNumber: row?.materialNumber,
        manufacturingLeadTime: row?.leadTime,
        paymentTerms: row?.paymentTerm,
        currency: row?.currency,
        uom: row?.uom
      }));
    } else if (procurementDivisionType === "Packaging") {
      reqBodyData = rowsData.map((row) => ({
        runOutputSeqId: row?.runOutputSeqId,
        sapSupplierId: row?.vendorNumber,
        sapMaterialNumber: row?.ccMaterialNo,
        manufacturingLeadTime: row?.manufacturingLeadTime,
        paymentTerms: row?.sapPaymentTerm,
        currency: row?.currency,
        uom: row?.uom
      }));
    } else if (procurementDivisionType === "CEPG") {
      reqBodyData = rowsData.map((row) => ({
        runOutputSeqId: row?.runOutputSeqId,
        sapSupplierId: row?.supplierNumber,
        sapMaterialNumber: row?.material,
        manufacturingLeadTime: row?.manufacturingLeadTime,
        paymentTerms: row?.paymentTerm,
        currency: row?.currency,
        uom: row?.uom
      }));
    }
    setReqBody(reqBodyData);
  }, [rowsData, procurementDivisionType]);

  const rowSelection = useMemo(() => {
        return {
          mode: "multiRow",
          isRowSelectable: (rowNode) => 
            rowNode.data && userRole !== "Viewer"
              ? true
              : false,
        };
      }, [userRole]);
  
  const getRowStyle = (params) => {
    if (params.data.status.toLowerCase().includes("email sent")) {
      return { backgroundColor: "#aaaaaa" };
    }
    return null;
  };

  const handleOpenEmailBox = () => {
    setOpen(true);
  };

  const getAllPriceMemoManagerEmail = useCallback(async () => {
    setLoading(true);
    try {
      const getAllPMEmails = await dispatch(
        getPriceMemoEmailApi({
          params: {
            procurementGroup: procurementDivisionType,
            plantId: plantId,
          },
        })
      );
      if (getAllPMEmails.meta.requestStatus === "fulfilled") {
        setLoading(false);
        setPriceMemoManagerEmails(getAllPMEmails?.payload);
      } else {
        console.error(
          "Something went wrong:",
          getAllPMEmails.error
        );
        toast.error(`Something went wrong - ${getAllPMEmails.error}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [dispatch, procurementDivisionType, plantId]);

  const getAllCpsMemberEmail = useCallback(async () => {
    setLoading(true);
    try {
      const getAllCPSEmails = await dispatch(
        getCpsMemberEmailApi({
          params: {
            plantId: plantId,
          },
        })
      );
      if (getAllCPSEmails.meta.requestStatus === "fulfilled") {
        setLoading(false);
        setCpsMemberEmails(getAllCPSEmails?.payload);
      } else {
        console.error(
          "Something went wrong:",
          getAllCPSEmails.error
        );
        toast.error(`Something went wrong - ${getAllCPSEmails.error}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [dispatch, plantId]);

  const handleSendEmail = async () => {
    setLoading(true);
    const emails = selectedPriceMemoManagerEmail?.map((email) => email.value);
    const cpsemails = selectedCPSMemberEmail?.map((email) => email.value);
    const cpsEmailsWithLoggedInUser = [...cpsemails, userEmail]

    try {
      const cpsCommentsList = rowsData.reduce((acc, row) => {
        acc[row.runOutputSeqId] = row.cpsComments;
        return acc;
      }, {});
      
      const sendMail = await dispatch(
        sendErrorMail({
          dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/sendDataErrorMail`,
          params: {
            plantId: plantId
          },
          data: {
            runOutputSeqIds: seqId,
            recipients: emails,
            ccRecipients: cpsEmailsWithLoggedInUser,
            runIdToCpsComments: cpsCommentsList
          },
        })
      );
      if (sendMail.meta.requestStatus === "fulfilled") {
        toast.success("Email sent successfully", {
          autoClose: 2000,
        });
        setOpen(false);
        setSeqId([]);
        setLoading(false);
        setIsBtnDisabled(true)
        setSelectedCPSMemberEmail([])
        setSelectedPriceMemoManagerEmail([])
        dispatch(
          fetchDataErrors({
            dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/dataErrors`,
            params: {
              plantId: plantId
            },
          })
        );
      } else {
        console.error(
          "moveToContract action failed:",
          sendMail.error
        );
        toast.error(`Something went wrong - ${sendMail.error}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const undoHandler = async () => {
    setLoading(true);
    try {
      const undoDE = await dispatch(
        undoDataErrorApi({
          dynamicEndpoint: `${undoDataErrorEndpoint}/${procurementDivisionType}/undoDataErrors`,
          params: {
            userId: userEmail,
            userName: cleanUsername(userName),
            plantId: plantId,
          },
          data: {
            runOutputSeqIds: seqId,
          },
        })
      );
      if (undoDE.meta.requestStatus === "fulfilled") {
        toast.success(undoDE?.payload?.responseMessage, {
          autoClose: 2000,
        });
        setLoading(false);
        dispatch(
          fetchDataErrors({
            dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/dataErrors`,
            params: {
              plantId: plantId
            },
          })
        );
        setIsBtnDisabled(true);
      } else {
        console.error(
          "Something went wrong:",
          undoDE.error
        );
        toast.error(`Something went wrong - ${undoDE.error}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getUniqueValues = (data = [], key) => {
    if (data?.length > 0) {
      return data.map(item => ({
        title: item.email,     
        value: item.email,
        name: item.username,    
        label: item.email,
      }));
    }
    else {
      return []
    }
  };

  const resolveHandler = async () => {
    setLoading(true);
    try {
      const resolvePM = await dispatch(
        resolvePriceMemo({
          dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/resolve`,
          params: {
            userId: cleanUsername(userName),
            plantId: plantId
          },
          data: reqBody,
        })
      );
      if (resolvePM.meta.requestStatus === "fulfilled") {
        toast.success("Price Memo updated successfully on AL", {
          autoClose: 2000,
        });
        setLoading(false);
        dispatch(
          fetchDataErrors({
            dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/dataErrors`,
            params: {
              plantId: plantId
            },
          })
        );
        setIsBtnDisabled(true);
      } else {
        console.error(
          "Something went wrong:",
          resolvePM?.payload?.message
        );
        toast.error(`Something went wrong - ${resolvePM?.payload?.message}`, {
          autoClose: 2000,
        });
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getDataErrorData = useCallback(() => {
      dispatch(
        fetchDataErrors({
          dynamicEndpoint: `api/cd/pricememo/${procurementDivisionType}/dataErrors`,
          params: {
            plantId: localStorage.getItem("selectedCDPlantCode")
          },
        })
      );
    }, [dispatch, procurementDivisionType]);

  const handleSelectedItemsChange = (name, selectedItems) => {
    if (name === "priceMemoManger") {
      setSelectedPriceMemoManagerEmail(selectedItems);
    } else if (name === "cpsMember") {
      setSelectedCPSMemberEmail(selectedItems);
    }
  }

  useEffect(() => {
    getDataErrorData();
    getAllPriceMemoManagerEmail();
    getAllCpsMemberEmail();
  }, [getDataErrorData, getAllPriceMemoManagerEmail, getAllCpsMemberEmail]);

  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Price Memo", path: "/price-memo" },
          { title: "Data Errors" },
        ]}
        hideHeader={true}
      />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className="priceMemo_main">
            {data?.loading === true || loading ? (
              <Loader />
            ) : !data?.data ? (
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                No record found
              </div>
            ) : (
              <div className="priceMemo_dataTable">
                <DataDetails
                  pagination={pagination}
                  paginationPageSize={paginationPageSize}
                  paginationPageSizeSelector={paginationPageSizeSelector}
                  onSelectionChanged={onSelectionChanged}
                  btnDisabled={btnDisabled}
                  data={data?.data}
                  rowSelection={rowSelection}
                  handleCellValueChange={handleCellValueChange}
                  getRowStyle={getRowStyle}
                  userRole={userRole}
                />
                <Alert
                  severity="info"
                  sx={{
                    padding: "2px 16px !important",
                    marginTop: "5px",
                    fontWeight: "bold",
                    fontSize: "15px !important",
                  }}
                >
                  Any changes done to the Price memo on this screen will remain
                  in AL itself. It will not change the source Price Memo data.
                </Alert>
                { userRole !== "Viewer" &&
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "30px",
                  }}
                >
                  <div>
                    <ButtonComponent
                      label="Back"
                      bgColor="#fff"
                      color="#000"
                      onClick={() => navigate("/price-memo")}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "280px",
                    }}
                  >
                    <ButtonComponent
                      label="Undo"
                      bgColor="#fff"
                      color="#000"
                      disabled={btnDisabled || undoBtnDisable}
                      onClick={undoHandler}
                    />
                    <ButtonComponent
                      label="Resolve"
                      bgColor="#000"
                      color="#fff"
                      disabled={btnDisabled}
                      onClick={resolveHandler}
                    />
                    <ButtonComponent
                      label="Send Email"
                      bgColor="#000"
                      color="#fff"
                      onClick={handleOpenEmailBox}
                      disabled={btnDisabled}
                    />
                  </div>
                </div>
                }
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      <Modal
        open={open}
        handleClose={handleClose}
        title="Email Address"
        content={
          loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "550px",
                height: "100px",
              }}
            >
              <CircularProgress color="inherit" />
            </Box>
          ) : (
            <div
              style={{
                width: "550px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Grid
                sx={{
                  width: "45%",
                  "& .MuiFormControl-root": { width: "100%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                  "& div": { marginTop: "5px" },
                }}
              >
                <label>Price Memo Manager</label>
                <MultiDropdown
                  id="priceMemoManger"
                  name="priceMemoManger"
                  options={getUniqueValues(priceMemoManagerEmails)}
                  label="Price Memo Manager"
                  selectedItemsData={selectedPriceMemoManagerEmail}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
              <Grid
                sx={{
                  width: "45%",
                  "& .MuiFormControl-root": { width: "100%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                  "& div": { marginTop: "5px" },
                }}
              >
                <label>CPS Members</label>
                <MultiDropdown
                  id="cpsMember"
                  name="cpsMember"
                  options={getUniqueValues(cpsMemberEmails)}
                  label="CPS Members"
                  selectedItemsData={selectedCPSMemberEmail}
                  onChangeItems={handleSelectedItemsChange}
                />
              </Grid>
            </div>
          )
        }
        action={
          <ModalFooter
            onClosePopup={handleClose}
            onSubmitPopup={handleSendEmail}
            selectedCPSMemberEmail={selectedCPSMemberEmail}
            selectedPriceMemoManagerEmail={selectedPriceMemoManagerEmail}
          />
        }
      />
    </>
  );
};

export default DataErrors;